import React, { useEffect } from 'react';
import SplashModal from './SplashModal';
import { useTextReveal } from '../hooks/useTextReveal';

// /book — the direct-booking request as its own page, in the guide's drawn
// picture-map style: a skyline poster with a 15% sticker on the left, and the
// three-step form (dates → Airbnb price → your details) on a paper sheet, with
// the steps drawn as stops on a route to the house.
// It's reached only from the one-time "15% off your next stay" email; the guide
// never links here (Airbnb off-platform policy), and search engines are asked
// not to index it.
const BookSkyline = () => (
  <svg className="book-skyline" viewBox="0 0 375 210" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
    <path d="M0 150q90-40 190-8t185-14V210H0Z" fill="#3E8E8A" stroke="#11172F" strokeWidth="2.5" />
    <path d="M248 160V70M240 70h16l-2-8h-12zM232 62q16-14 32 0zM248 48V38" fill="#FFF7E6" stroke="#11172F" strokeWidth="2.5" strokeLinejoin="round" />
    <rect x="60" y="118" width="26" height="50" fill="#263A72" stroke="#11172F" strokeWidth="2.5" />
    <rect x="90" y="96" width="30" height="72" fill="#F3C35B" stroke="#11172F" strokeWidth="2.5" />
    <rect x="124" y="126" width="24" height="42" fill="#E4573D" stroke="#11172F" strokeWidth="2.5" />
    <rect x="290" y="124" width="28" height="44" fill="#263A72" stroke="#11172F" strokeWidth="2.5" />
    <path d="M0 180q90-20 190 0t185-6V210H0Z" fill="#263A72" />
  </svg>
);

const BookPage: React.FC = () => {
  useTextReveal();
  useEffect(() => {
    document.title = 'Book your next stay · Corazón Townhouse';
    const robots = document.createElement('meta');
    robots.name = 'robots';
    robots.content = 'noindex, nofollow';
    document.head.appendChild(robots);
    return () => robots.remove();
  }, []);

  return (
    <div className="book-page">
      <main className="book-layout">
        <section className="book-hero" aria-labelledby="book-hero-title">
          <p className="book-hero-eyebrow">Your next stay</p>
          <h1 id="book-hero-title" className="book-hero-title">
            Come back <em>to the Hill.</em>
          </h1>
          <figure className="book-hero-poster" aria-hidden="true">
            <span className="book-sticker">
              <b>15%</b>
              <small>off next time</small>
            </span>
            <BookSkyline />
          </figure>
          <p className="book-hero-note">
            For future stays only — your current reservation stays on Airbnb.
          </p>
        </section>

        <div className="book-form">
          <SplashModal isOpen variant="page" onClose={() => window.location.assign('/')} />
        </div>
      </main>
    </div>
  );
};

export default BookPage;
